import { useState } from "react";

import RemoveIcon from "../../../../../components/RemoveIcon";
import Dialog from "./Dialog";

const RemoveButton = ({ userId }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};
	return (
		<>
			<RemoveIcon onClick={handleClickOpen} />
			<Dialog open={open} onClose={handleClose} userId={userId} />
		</>
	);
};

export default RemoveButton;
